import { useSearchParams } from 'next/navigation';

import { mergeQueryParameters } from '@packages/shared/src/utils/mergeQueryParameters/mergeQueryParameters';
import { searchParamsToObject } from '@packages/shared/src/utils/searchParamsToObject/searchParamsToObject';

import { encodePage } from '../queryEncoding';

export const useHrefWithPageNumber = (href: string, pageNumber: number) => {
  const searchParams = useSearchParams();
  const query = searchParamsToObject(searchParams);

  return mergeQueryParameters(href, {
    ...query,
    // Page number is included in the query, but the semantic meaning is different for infinite scrolling.
    // The page number included in the query is the "last loaded" page number, while the `pageNumber` from the props is the page the card is located in
    // This is important for back navigation, to load the correct page of products
    ...(pageNumber && encodePage(pageNumber)),
  });
};
